type ConversationCallDisplayLike = {
    readonly created_at: string;
    readonly direction: string;
    readonly call_summary: string | null;
    readonly transcript_preview: string | null;
    readonly started_at?: string | null;
};

export function isOutboundConversationCall(call: {
    readonly direction: string;
}): boolean {
    return call.direction === 'outbound';
}

export function getConversationCallTitle(call: {
    readonly direction: string;
}): string {
    return isOutboundConversationCall(call) ? 'Outbound Call' : 'Inbound Call';
}

export function getConversationCallPreviewText(
    call: ConversationCallDisplayLike | null | undefined,
): string | null {
    if (!call) {
        return null;
    }

    const previewText = call.call_summary ?? call.transcript_preview;
    if (!previewText) {
        return getConversationCallTitle(call);
    }

    const normalizedContent = previewText.replace(/\s+/g, ' ').trim();
    return normalizedContent || getConversationCallTitle(call);
}

export function getConversationCallTimestamp(
    call: ConversationCallDisplayLike,
): string {
    return call.started_at ?? call.created_at;
}
